/**
 * # angular-elastic-builder
 * ## Angular Module for building an Elasticsearch Query
 *
 * @version v1.5.1
 * @link https://github.com/dncrews/angular-elastic-builder.git
 * @license MIT
 * @author Dan Crews <crewsd@gmail.com>
 */

/**
 * angular-elastic-builder
 *
 * /src/module.js
 *
 * Angular Module for building an Elasticsearch query
 */

(function (angular) {
    'use strict';

    angular.module('angular-elastic-builder', [
        'RecursionHelper',
        'ui.bootstrap',
    ]);

})(window.angular);

/**
 * angular-elastic-builder
 *
 * /src/directives/BuilderDirective.js
 *
 * Angular Directive for injecting a query builder form.
 */

(function (angular) {
    'use strict';

    angular.module('angular-elastic-builder')
        .directive('elasticBuilder', [
            'elasticQueryService',

            function EB(elasticQueryService) {

                return {
                    scope: {
                        data: '=elasticBuilder',
                    },

                    templateUrl: 'angular-elastic-builder/BuilderDirective.html',

                    link: function (scope) {
                        var data = scope.data;

                        scope.filters = [];

                        /**
                         * Removes either Group or Rule
                         */
                        scope.removeChild = function (idx) {
                            scope.filters.splice(idx, 1);
                        };

                        /**
                         * Adds a Single Rule
                         */
                        scope.addRule = function () {
                            scope.filters.push({});
                        };

                        /**
                         * Adds a Group of Rules
                         */
                        scope.addGroup = function () {
                            scope.filters.push({
                                type: 'group',
                                subType: 'and',
                                rules: [],
                            });
                        };

                        /**
                         * Any time "outside forces" change the query, they should tell us so via
                         * `data.needsUpdate`
                         */
                        scope.$watch('data.needsUpdate', function (curr) {
                            if (!curr) return;

                            scope.filters = elasticQueryService.toFilters(data.query, scope.data.fields);
                            if (data.dateQuery) {
                                scope.filters = scope.filters.concat(elasticQueryService.toFilters(data.dateQuery, scope.data.fields));
                            }
                            scope.data.needsUpdate = false;
                        });

                        /**
                         * Changes on the page update the Query
                         */
                        scope.$watch('filters', function (curr) {
                            if (!curr) return;

                            data.query = elasticQueryService.toQuery(scope.filters, scope.data.fields);
                            data.dateQuery = elasticQueryService.toDateQuery(scope.filters, scope.data.fields);
                        }, true);
                    },
                };
            },

        ]);

})(window.angular);

/**
 * angular-elastic-builder
 *
 * /src/directives/Chooser.js
 *
 * This file is to help recursively, to decide whether to show a group or rule
 */

(function (angular) {
    'use strict';

    var app = angular.module('angular-elastic-builder');

    app.directive('elasticBuilderChooser', [
        'RecursionHelper',
        'groupClassHelper',

        function elasticBuilderChooser(RH, groupClassHelper) {

            return {
                scope: {
                    elasticFields: '=',
                    item: '=elasticBuilderChooser',
                    onRemove: '&',
                },

                templateUrl: 'angular-elastic-builder/ChooserDirective.html',

                compile: function (element) {
                    return RH.compile(element, function (scope, el, attrs) {
                        var depth = scope.depth = (+attrs.depth)
                            , item = scope.item;

                        scope.getGroupClassName = function () {
                            var level = depth;
                            if (item.type === 'group') level++;

                            return groupClassHelper(level);
                        };
                    });
                },
            };
        },

    ]);

})(window.angular);

/**
 * angular-elastic-builder
 *
 * /src/directives/Group.js
 */

(function (angular) {
    'use strict';

    var app = angular.module('angular-elastic-builder');

    app.directive('elasticBuilderGroup', [
        'RecursionHelper',
        'groupClassHelper',

        function elasticBuilderGroup(RH, groupClassHelper) {

            return {
                scope: {
                    elasticFields: '=',
                    group: '=elasticBuilderGroup',
                    onRemove: '&',
                },

                templateUrl: 'angular-elastic-builder/GroupDirective.html',

                compile: function (element) {
                    return RH.compile(element, function (scope, el, attrs) {
                        var depth = scope.depth = (+attrs.depth);
                        var group = scope.group;

                        scope.addRule = function () {
                            group.rules.push({});
                        };
                        scope.addGroup = function () {
                            group.rules.push({
                                type: 'group',
                                subType: 'and',
                                rules: [],
                            });
                        };

                        scope.removeChild = function (idx) {
                            group.rules.splice(idx, 1);
                        };

                        scope.getGroupClassName = function () {
                            return groupClassHelper(depth + 1);
                        };
                    });
                },
            };
        },

    ]);

})(window.angular);

/**
 * angular-elastic-builder
 *
 * /src/directives/Rule.js
 */

(function (angular) {
    'use strict';

    var app = angular.module('angular-elastic-builder');

    app.directive('elasticBuilderRule', [

        function elasticBuilderRule() {
            return {
                scope: {
                    elasticFields: '=',
                    rule: '=elasticBuilderRule',
                    onRemove: '&',
                },

                templateUrl: 'angular-elastic-builder/RuleDirective.html',

                link: function (scope) {
                    scope.getType = function () {
                        var fields = scope.elasticFields;

                        if (scope.rule.field) {
                            var field = fields.findIndex(function (item) {
                                return item.displayName === scope.rule.field.displayName;
                            });
                            scope.rule.field.fieldIndex = field;
                        }

                        if (!fields || field === undefined) return;

                        return fields[field].type;
                    };
                    scope.clearValues = function () {
                        scope.rule.subType = null;
                        scope.rule.values = null;
                        scope.rule.value = null;
                    };
                },
            };
        },

    ]);

})(window.angular);

/**
 * angular-elastic-builder
 *
 * /src/directives/RuleTypes.js
 *
 * Determines which Rule type should be displayed
 */

(function (angular) {
    'use strict';

    var app = angular.module('angular-elastic-builder');

    app.directive('elasticType', ['$http', '$rootScope', elasticType]);

    function elasticType($http, $rootScope) {
        return {
            scope: {
                type: '=elasticType',
                rule: '=',
                guide: '='
            },

            template: '<ng-include src="getTemplateUrl()" />',

            link: function (scope) {
                scope.getTemplateUrl = function () {
                    var type = scope.type;
                    if (!type) return;
                    if (typeof type !== 'string') return;
                    type = type.charAt(0).toUpperCase() + type.slice(1);

                    return 'angular-elastic-builder/types/' + type + '.html';
                };

                // This is a weird hack to make sure these are numbers
                scope.booleans = ['False', 'True'];
                scope.booleansOrder = ['True', 'False'];

                scope.datesNeeded = function () {
                    var needs = [
                        'Range'
                    ];

                    return ~needs.indexOf(scope.rule.subType);
                };

                scope.timeNeeded = function () {
                    var needs = [
                        'Equals',
                        'LessThan',
                        'GreaterThan'
                    ];

                    return ~needs.indexOf(scope.rule.subType);
                };

                scope.inputNeeded = function () {
                    var needs = [
                        'LastNumberOf',
                        'Equals',
                        'NotEquals',
                        'GreaterThan',
                        'GreaterThanOrEqual',
                        'LessThan',
                        'LessThanOrEqual',
                        'Contains',
                        'DoesNotContain',
                        'StartsWith',
                        'EndsWith'
                    ];

                    return ~needs.indexOf(scope.rule.subType);
                };

                scope.multiNeeded = function () {
                    var needs = [
                        'Equals',
                        'NotEquals'
                    ];

                    return ~needs.indexOf(scope.rule.subType);
                };

                scope.periodNeeded = function () {
                    var needs = [
                        'Previous',
                        'ToDate'
                    ];

                    return ~needs.indexOf(scope.rule.subType);
                };

                scope.pluralPeriodNeeded = function () {
                    var needs = [
                        'LastNumberOf'
                    ];

                    return ~needs.indexOf(scope.rule.subType);
                };

                scope.today = function () {
                    scope.rule.date = new Date();
                };
                scope.today();

                scope.clear = function () {
                    scope.rule.date = null;
                };

                scope.startDateOptions = {
                    dateDisabled: scope.disabled,
                    formatYear: 'yy',
                    maxDate: new Date(),
                    startingDay: 1,
                    showWeeks: false
                };

                scope.endDateOptions = {
                    formatYear: 'yy',
                    maxDate: new Date(),
                    startingDay: 1,
                    showWeeks: false
                };

                scope.disabled = function (data) {
                    var date = data.date,
                        mode = data.mode;
                    return mode === 'day' && date > scope.rule.endDate;
                };

                scope.open1 = function () {
                    scope.popup1.opened = true;
                };

                scope.open2 = function () {
                    scope.popup2.opened = true;
                };

                scope.setDate = function (year, month, day) {
                    scope.rule.date = new Date(year, month - 1, day);
                };

                scope.popup1 = { opened: false };
                scope.popup2 = { opened: false };

                if (!scope.rule.startTime && !scope.rule.endTime) {
                    scope.rule.startTime = new Date;
                    scope.rule.startTime.setHours(0, 0, 0, 0);
                    scope.rule.endTime = new Date;
                    scope.rule.endTime.setHours(0, 0, 0, 0);
                }

                scope.getChoices = function (criteria) {
                    if (scope.rule.values && scope.rule.values.length > 0) {
                        var defaultValues = angular.copy(scope.rule.values);
                    }
                    $http.get(apiUrl + criteria.link).then(function (response) {
                        if (response.data.length === 0) { return; }
                        if (response.data.some(function (choice) { return choice.UserHasAccess === false; })) {
                            response.data = response.data.filter(function (choice) { return choice.UserHasAccess; });
                        }
                        var choices = angular.copy(response.data);
                        var parentVm = scope.$parent.$parent.$parent.$parent.$parent.$parent.vm;
                        if (choices.length > 0 && choices[0].RulesetId) {
                            choices = choices.filter(function (row) {
                                return row.RulesetId === parentVm.selectedRuleset.RulesetId;
                            });
                        }
                        if (choices[0].ProductType && parentVm.selectedProducts && parentVm.selectedProducts.length === 1) {
                            choices = choices.filter(function (row) {
                                return row.ProductType === parentVm.selectedProducts[0].Type;
                            });
                        }
                        if (choices[0].ProductType && parentVm.selectedProduct) {
                            choices = choices.filter(function (row) {
                                return row.ProductType === parentVm.selectedProduct.Type;
                            });
                        }
                        var mappedData = choices.map(function (item) {
                            return {
                                'Name': item[criteria.label],
                                'Id': item[criteria.identifier]
                            };
                        });
                        scope.guide.choices = mappedData;
                        if (defaultValues) {
                            scope.rule.values = [];
                            for (var i = 0; i < defaultValues.length; i++) {
                                var defaultValue = defaultValues[i];
                                var valueToAdd = mappedData.find(function (row) {
                                    return row.Id === defaultValue.Id;
                                });
                                if (!valueToAdd) {
                                    valueToAdd = mappedData.find(function (row) {
                                        return row.Name === defaultValue.Id;
                                    });
                                }
                                scope.rule.values.push(valueToAdd);
                                scope.rule.values = scope.rule.values.filter(function (value) {
                                    return value.Name;
                                });
                            }
                        }
                    });
                };

                scope.clearValues = function (route) {
                    scope.rule.values = null;
                    scope.rule.value = null;
                };
            }

        };
    }

})(window.angular);

/**
 * angular-elastic-builder
 *
 * /src/services/GroupClassHelper.js
 *
 * This keeps all of the groups colored correctly
 */

(function (angular) {
    'use strict';

    angular.module('angular-elastic-builder')
        .factory('groupClassHelper', function groupClassHelper() {

            return function (level) {
                var levels = [
                    '',
                    'list-group-item-info',
                    'list-group-item-success',
                    'list-group-item-warning',
                    'list-group-item-danger',
                ];

                return levels[level % levels.length];
            };
        });

})(window.angular);

/**
 * angular-elastic-builder
 *
 * /src/services/QueryService.js
 *
 * This file is used to convert filters into queries, and vice versa
 */

(function (angular) {
    'use strict';

    angular.module('angular-elastic-builder')
        .factory('elasticQueryService', [
            '$filter',

            function ($filter) {

                return {
                    toFilters: toFilters,
                    toQuery: function (userFilters, fields) {
                        return toQuery(userFilters, fields, $filter);
                    },
                    toDateQuery: function (userFilters, fields) {
                        return toDateQuery(userFilters, fields, $filter);
                    }
                };
            }
        ]);

    function toFilters(query, fields) {
        var filters = parseQueryGroup(query, fields);

        return filters;
    }

    function toQuery(userFilters, fields, $filter) {
        var query = parseFilterGroup(userFilters, fields, $filter);
        return query;
    }

    function toDateQuery(userFilters, fields, $filter) {
        var dateQuery = parseDateFilterGroup(userFilters, fields);
        return dateQuery;
    }

    function parseQueryGroup(query, fields) {
        if (!fields || !query) return;

        var filtersArray = [];

        for (var i = 0; i < query.length; i++) {
            var filterObject = {};
            var queryObject = query[i];
            var matchingField = fields.find(function (field) {
                if (queryObject.DisplayName) {
                    return field.displayName.toLowerCase() === queryObject.DisplayName.toLowerCase() && field.fieldName.toLowerCase() === queryObject.FieldName.toLowerCase();
                } else {
                    return field.fieldName.toLowerCase() === queryObject.FieldName.toLowerCase();
                }
            });

            if (!matchingField) {
                // need to look for textField
                for (var key in fields) {
                    if (fields[key].textField === queryObject.FieldName) {
                        matchingField = fields[key];
                    }
                }
            }
            // Operator needs to be capitalized
            var operator = queryObject.Operator;
            if (operator) {
                operator = operator.charAt(0).toUpperCase() + operator.substr(1);
            }

            filterObject.field = matchingField;

            if (matchingField.type === "Multi" && (operator === "Equals" || operator === "NotEquals")) {
                filterObject.subType = operator;
                filterObject.value = null;
                // First check if there's already an object for this Filter
                var existingFilterIndex = filtersArray.findIndex(function (f) { return f.field.fieldName === queryObject.FieldName; });
                if (existingFilterIndex >= 0) {
                    // Take the value from this Filter and add it to the existing one
                    var filterValueObject = {};
                    filterValueObject.Name = queryObject.ValueName;
                    filterValueObject.Id = queryObject.Value;
                    filtersArray[existingFilterIndex].values.push(filterValueObject);
                } else {
                    // We need to set up an array of values for the multi select
                    filterObject.value = null;
                    filterObject.values = [];
                    var filterValueObject = {};
                    filterValueObject.Name = queryObject.ValueName;
                    filterValueObject.Id = queryObject.Value;
                    filterObject.values.push(filterValueObject);
                    filtersArray.push(filterObject);
                }
            } else if ((matchingField.type.toUpperCase() === "DATE" || matchingField.type.toUpperCase() === "DATETIME") && (queryObject.DateType || queryObject.Operator.includes('ThanOrEqual'))) {
                var date = new Date(queryObject.Value);
                if (queryObject.Operator === "GreaterThanOrEqual" || queryObject.Operator === "LessThanOrEqual") {
                    var existingDateFilterIndex = filtersArray.findIndex(function (filter) { return filter.field.fieldName === queryObject.FieldName; });
                    if (existingDateFilterIndex > -1) {
                        if (matchingField.type === "DateTime") {
                            filtersArray[existingDateFilterIndex].endTime = date;
                        }
                        filtersArray[existingDateFilterIndex].endDate = date;
                    } else {
                        filterObject.subType = 'Range';
                        filterObject.startDate = date;
                        filterObject.startTime = date;
                        filtersArray.push(filterObject);
                    }
                } else {
                    // Handle non date range filters here
                    filterObject.subType = queryObject.DateType;
                    filterObject.periodType = queryObject.Period;
                    filterObject.value = queryObject.Value;
                    filtersArray.push(filterObject);
                }
            } else {
                filterObject.subType = operator;
                filterObject.value = query[i].Value;
                if (filterObject.value === true) { filterObject.value = 1; }
                if (filterObject.value === false) { filterObject.value = 0; }
                filterObject.values = null;
                filtersArray.push(filterObject);
            }
        }
        return filtersArray;

    }


    function parseFilterGroup(userFilters, fields, $filter) {
        if (!fields || !userFilters) return;

        var queryArray = [];

        for (var i = 0; i < userFilters.length; i++) {
            var filterObject = {};
            if (userFilters[i].field) {
                var fieldName = userFilters[i].field.fieldName;
                var fieldIndex = fields.findIndex(function (item) { return item.displayName === userFilters[i].field.displayName; });
            } else {
                continue;
            }

            var fieldData = fields[fieldIndex];

            if (fieldIndex < 0) continue;

            switch (fieldData.type.toUpperCase()) {
                case 'STRING':
                    if (!userFilters[i].subType) continue;

                    filterObject.FieldName = fieldName;
                    filterObject.Value = userFilters[i].value;
                    filterObject.Operator = userFilters[i].subType;
                    break;
                case 'BOOLEAN':
                    filterObject.FieldName = fieldName;
                    filterObject.Value = userFilters[i].value;
                    filterObject.Operator = 'Equals';
                    break;
                case 'NUMBER':
                    if (!userFilters[i].subType) continue;
                    filterObject.FieldName = fieldName;
                    filterObject.Value = userFilters[i].value;
                    filterObject.Operator = userFilters[i].subType;
                    break;
                case 'DATE':
                case 'DATETIME':
                    if (fieldData.type.toUpperCase() === 'DATETIME' && (!userFilters[i].startTime || !userFilters[i].endTime)) continue;
                    if (userFilters[i].subType === 'IsEmpty' || userFilters[i].subType === 'IsNotEmpty') {
                        filterObject.FieldName = fieldName;
                        filterObject.Value = userFilters[i].value;
                        filterObject.Operator = userFilters[i].subType;
                        queryArray.push(filterObject);
                        continue;
                    }

                    if (userFilters[i].subType !== 'Range') continue;
                    if (!userFilters[i].startDate || !userFilters[i].endDate) continue;
                    var startDate = {};
                    var endDate = {};
                    startDate.FieldName = fieldName;
                    startDate.Operator = 'GreaterThanOrEqual';
                    startDate.Value = userFilters[i].startDate;
                    endDate.FieldName = fieldName;
                    endDate.Operator = 'LessThanOrEqual';
                    endDate.Value = userFilters[i].endDate;

                    if (fieldData.type.toUpperCase() === 'DATETIME') {
                        if (!userFilters[i].startTime || !userFilters[i].endTime) continue;

                        var startTimeHours = userFilters[i].startTime.getHours();
                        var startTimeMinutes = userFilters[i].startTime.getMinutes();
                        startDate.Value.setHours(startTimeHours);
                        startDate.Value.setMinutes(startTimeMinutes);

                        var endTimeHours = userFilters[i].endTime.getHours();
                        var endTimeMinutes = userFilters[i].endTime.getMinutes();
                        endDate.Value.setHours(endTimeHours);
                        endDate.Value.setMinutes(endTimeMinutes);
                    }

                    if (startDate.Value && endDate.Value) {
                        queryArray.push(startDate);
                        queryArray.push(endDate);
                    }
                    break;
                case 'MULTI':
                    if (!userFilters[i].subType) continue;
                    switch (userFilters[i].subType) {
                        case 'Contains':
                        case 'DoesNotContain':
                        case 'StartsWith':
                        case 'EndsWith':
                        case 'IsEmpty':
                        case 'IsNotEmpty':
                            if (!userFilters[i].value && userFilters[i].subType !== 'IsEmpty' && userFilters[i].subType !== 'IsNotEmpty') continue;
                            filterObject.FieldName = userFilters[i].field.textField;
                            filterObject.Operator = userFilters[i].subType;
                            filterObject.Value = userFilters[i].value;
                            break;
                        case 'Equals':
                        case 'NotEquals':
                            if (!userFilters[i].values) continue;
                            for (var a = 0; a < userFilters[i].values.length; a++) {
                                var multiFilter = {};
                                if (userFilters[i].values[a].Name) {
                                    multiFilter.FieldName = fieldName;
                                } else {
                                    multiFilter.FieldName = userFilters[i].field.textField;
                                }
                                multiFilter.Operator = userFilters[i].subType;
                                multiFilter.Value = userFilters[i].values[a].Id;
                                multiFilter.CriteriaValue = userFilters[i].values[a].Name;
                                multiFilter.CriteriaDisplayName = userFilters[i].field.displayName;
                                queryArray.push(multiFilter);
                            }
                    }
                    break;
                case 'TIME':
                    if (!userFilters.subType) continue;

                    filterObject.Value = formatDate($filter, userFilters[i].time, 'shortTime');
                    filterObject.FieldName = fieldName;
                    filterObject.Operator = userFilters[i].subType;
                    break;
                default:
                    break;
            }
            if (filterObject.Value !== undefined && fieldData.type !== 'Boolean') {
                queryArray.push(filterObject);
            } else if (fieldData.type === 'Boolean') {
                queryArray.push(filterObject);
            }
        }
        return queryArray;
    }

    function parseDateFilterGroup(userFilters, fields) {
        if (!fields || !userFilters) return;

        var dateQueryArray = [];

        for (var i = 0; i < userFilters.length; i++) {
            var filterObject = {};
            if (userFilters[i].field) {
                var fieldName = userFilters[i].field.fieldName;
                var fieldData = fields.find(function (f) {
                    return f.fieldName === fieldName;
                });
            }
            if (!fieldData || !userFilters[i].subType || userFilters[i].subType === 'Range') continue;

            if (fieldData.type.toUpperCase() === 'DATE' || fieldData.type.toUpperCase() === 'DATETIME') {
                if (userFilters[i].subType === 'IsEmpty' || userFilters[i].subType === 'IsNotEmpty') continue;

                filterObject.DateType = userFilters[i].subType;
                filterObject.FieldName = fieldName;
                filterObject.Period = userFilters[i].periodType;
                filterObject.Value = userFilters[i].value;

                dateQueryArray.push(filterObject);
            }
        }

        return dateQueryArray;
    }

    function getFilterTemplate(type) {
        var templates = {
            group: {
                type: 'group',
                subType: '',
                rules: []
            },
            item: {
                field: '',
                subType: '',
                value: ''
            },
            number: {
                field: '',
                subType: '',
                value: null
            }
        };

        return angular.copy(templates[type]);
    }

    function formatDate($filter, date, dateFormat) {
        if (!angular.isDate(date)) return false;
        var fDate = $filter('date')(date, dateFormat);
        return fDate;
    }

})(window.angular);

(function(angular) {"use strict"; angular.module("angular-elastic-builder").run(["$templateCache", function($templateCache) {$templateCache.put("angular-elastic-builder/BuilderDirective.html","<div class=\"elastic-builder\">\r\n    <div class=\"filter-panels\">\r\n        <div class=\"form-inline\">\r\n            <div data-ng-repeat=\"filter in filters\"\r\n                 data-elastic-builder-chooser=\"filter\"\r\n                 data-elastic-fields=\"data.fields\"\r\n                 data-on-remove=\"removeChild($index)\"\r\n                 data-depth=\"0\"></div>\r\n            <div class=\"actions m-t-sm\">\r\n                <a class=\"btn btn-xs btn-primary\" title=\"Add Rule\" data-ng-click=\"addRule()\">\r\n                    <span>Add Filter </span><i class=\"fa fa-plus\"></i>\r\n                </a>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("angular-elastic-builder/ChooserDirective.html","<div class=\"elastic-builder-chooser\"\r\n     data-ng-class=\"getGroupClassName()\">\r\n\r\n    <div data-ng-if=\"item.type === \'group\'\"\r\n         data-elastic-builder-group=\"item\"\r\n         data-depth=\"{{ depth }}\"\r\n         data-elastic-fields=\"elasticFields\"\r\n         data-on-remove=\"onRemove()\"></div>\r\n\r\n    <div data-ng-if=\"item.type !== \'group\'\"\r\n         data-elastic-builder-rule=\"item\"\r\n         data-elastic-fields=\"elasticFields\"\r\n         data-on-remove=\"onRemove()\"></div>\r\n\r\n</div>\r\n");
$templateCache.put("angular-elastic-builder/GroupDirective.html","<div class=\"elastic-builder-group\">\r\n    <h5>\r\n        If\r\n        <select data-ng-model=\"group.subType\" class=\"form-control\">\r\n            <option value=\"and\">all</option>\r\n            <option value=\"or\">any</option>\r\n        </select>\r\n        of these conditions are met\r\n    </h5>\r\n    <div data-ng-repeat=\"rule in group.rules\"\r\n         data-elastic-builder-chooser=\"rule\"\r\n         data-elastic-fields=\"elasticFields\"\r\n         data-depth=\"{{ +depth + 1 }}\"\r\n         data-on-remove=\"removeChild($index)\"></div>\r\n\r\n    <div class=\"list-group-item actions\" data-ng-class=\"getGroupClassName()\">\r\n        <a class=\"btn btn-xs btn-primary\" title=\"Add Sub-Rule\" data-ng-click=\"addRule()\">\r\n            <i class=\"fa fa-plus\"></i>\r\n        </a>\r\n        <a class=\"btn btn-xs btn-primary\" title=\"Add Sub-Group\" data-ng-click=\"addGroup()\">\r\n            <i class=\"fa fa-list\"></i>\r\n        </a>\r\n    </div>\r\n\r\n    <a class=\"btn btn-xs btn-danger remover\" data-ng-click=\"onRemove()\">\r\n        <i class=\"fa fa-minus\"></i>\r\n    </a>\r\n</div>\r\n");
$templateCache.put("angular-elastic-builder/RuleDirective.html","<div class=\"elastic-builder-rule\">\r\n    <div class=\"inline-block m-b-sm\">\r\n        <div class=\"form-group\">\r\n            <label>Filter On</label>\r\n            <select class=\"criteria-drop\"\r\n                    data-ng-model=\"rule.field\"\r\n                    data-ng-options=\"value as value.displayName for (key, value) in elasticFields\"\r\n                    data-ng-change=\"clearValues()\"></select>\r\n        </div>\r\n        <span data-elastic-type=\"getType()\" data-rule=\"rule\" data-guide=\"elasticFields[rule.field.fieldIndex]\"></span>\r\n        <a class=\"btn btn-xs btn-text-only remover m-t-md\" data-ng-click=\"onRemove()\">\r\n            <i class=\"fa fa-lg fa-trash-o text-danger\"></i>\r\n        </a>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("angular-elastic-builder/types/Boolean.html","<div class=\"boolean-rule inline-block\">\r\n    <div class=\"inline-block\">\r\n        <div class=\"form-group\">\r\n            <label>Equals</label>\r\n            <!-- This is a weird hack to make sure these are numbers -->\r\n            <select data-ng-model=\"rule.value\"\r\n                    class=\"criteria-drop\"\r\n                    data-ng-options=\"booleans.indexOf(choice) as choice for choice in booleansOrder\"></select>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("angular-elastic-builder/types/Date.html","<div class=\"date-rule inline-block\">\r\n    <div class=\"inline-block\">\r\n        <div class=\"form-group\">\r\n            <label>Operator</label>\r\n            <select data-ng-model=\"rule.subType\" class=\"criteria-drop\" ng-change=\"clearValues()\">\r\n                <option value=\"Range\">Date Range</option>\r\n                <option value=\"Previous\">Previous</option>\r\n                <option value=\"ToDate\">Current</option>\r\n                <option value=\"LastNumberOf\">Last</option>\r\n                <option data-ng-if=\"rule.field.isNullable\" value=\"IsEmpty\">Is empty</option>\r\n                <option data-ng-if=\"rule.field.isNullable\" value=\"IsNotEmpty\">Is not empty</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"inline-block\" data-ng-if=\"datesNeeded()\">\r\n        <div class=\"form-group\">\r\n            <label>Start Date</label>\r\n            <div class=\"input-group\">\r\n                <input type=\"text\"\r\n                       class=\"criteria-drop-date-pick\"\r\n                       show-button-bar=\"false\"\r\n                       data-uib-datepicker-popup=\"shortDate\"\r\n                       data-ng-model=\"rule.startDate\"\r\n                       data-is-open=\"popup1.opened\"\r\n                       data-datepicker-options=\"startDateOptions\"\r\n                       data-ng-required=\"true\"\r\n                       data-close-text=\"Close\"\r\n                       required />\r\n                <span class=\"input-group-btn\">\r\n                    <button type=\"button\" class=\"btn btn-default criteria-attached-button\" ng-click=\"open1()\">\r\n                        <i class=\"fa fa-calendar\"></i>\r\n                    </button>\r\n                </span>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"inline-block\" data-ng-if=\"datesNeeded()\">\r\n        <div class=\"form-group\">\r\n            <label>End Date</label>\r\n            <div class=\"input-group\">\r\n                <input type=\"text\"\r\n                       class=\"criteria-drop-date-pick\"\r\n                       show-button-bar=\"false\"\r\n                       data-uib-datepicker-popup=\"shortDate\"\r\n                       data-ng-model=\"rule.endDate\"\r\n                       data-is-open=\"popup2.opened\"\r\n                       data-datepicker-options=\"endDateOptions\"\r\n                       data-ng-required=\"true\"\r\n                       data-close-text=\"Close\"\r\n                       required />\r\n                <span class=\"input-group-btn\">\r\n                    <button type=\"button\" class=\"btn btn-default criteria-attached-button\" ng-click=\"open2()\">\r\n                        <i class=\"fa fa-calendar\"></i>\r\n                    </button>\r\n                </span>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <div class=\"inline-block\" data-ng-if=\"inputNeeded()\">\r\n        <div class=\"form-group\">\r\n            <label>#</label>\r\n            <input type=\"number\" class=\"criteria-number\" data-ng-model=\"rule.value\" min=0>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"inline-block\" data-ng-if=\"periodNeeded() || pluralPeriodNeeded()\">\r\n        <div class=\"form-group\">\r\n            <label>Period</label>\r\n            <select data-ng-model=\"rule.periodType\" class=\"criteria-drop\" data-ng-if=\"periodNeeded()\">\r\n                <option value=\"Day\">Day</option>\r\n                <option value=\"Week\">Week</option>\r\n                <option value=\"Month\">Month</option>\r\n                <option value=\"Quarter\">Quarter</option>\r\n                <option value=\"Year\">Year</option>\r\n            </select>\r\n            <select data-ng-model=\"rule.periodType\" class=\"criteria-drop\" data-ng-if=\"pluralPeriodNeeded()\">\r\n                <option value=\"Day\">Day(s)</option>\r\n                <option value=\"Week\">Week(s)</option>\r\n                <option value=\"Month\">Month(s)</option>\r\n                <option value=\"Year\">Year(s)</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("angular-elastic-builder/types/DateTime.html","<div class=\"date-time-rule inline-block\">\r\n    <div class=\"inline-block\">\r\n        <div class=\"form-group\">\r\n            <label>Operator</label>\r\n            <select data-ng-model=\"rule.subType\" class=\"criteria-drop\" ng-change=\"clearValues()\">\r\n                <option value=\"Range\">Date Range</option>\r\n                <option value=\"Previous\">Previous</option>\r\n                <option value=\"ToDate\">Current</option>\r\n                <option value=\"LastNumberOf\">Last</option>\r\n                <option data-ng-if=\"rule.field.isNullable\" value=\"IsEmpty\">Is empty</option>\r\n                <option data-ng-if=\"rule.field.isNullable\" value=\"IsNotEmpty\">Is not empty</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"inline-block\" data-ng-if=\"datesNeeded()\">\r\n        <div class=\"form-group\">\r\n            <label>Start Date</label>\r\n            <div class=\"input-group\">\r\n                <input type=\"text\"\r\n                       class=\"criteria-drop-date-pick\"\r\n                       show-button-bar=\"false\"\r\n                       data-uib-datepicker-popup=\"shortDate\"\r\n                       data-ng-model=\"rule.startDate\"\r\n                       data-is-open=\"popup1.opened\"\r\n                       data-datepicker-options=\"startDateOptions\"\r\n                       data-ng-required=\"true\"\r\n                       data-close-text=\"Close\"\r\n                       required />\r\n                <span class=\"input-group-btn\">\r\n                    <button type=\"button\" class=\"btn btn-default criteria-attached-button\" ng-click=\"open1()\">\r\n                        <i class=\"fa fa-calendar\"></i>\r\n                    </button>\r\n                </span>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"inline-block\" data-ng-if=\"datesNeeded()\">\r\n        <div class=\"form-group\">\r\n            <label>Start Time</label>\r\n            <span uib-timepicker\r\n                  data-ng-model=\"rule.startTime\"\r\n                  class=\"criteria-time\"\r\n                  hour-step=\"1\"\r\n                  minute-step=\"1\"\r\n                  show-spinners=\"false\"\r\n                  required />\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"inline-block\" data-ng-if=\"datesNeeded()\">\r\n        <div class=\"form-group\">\r\n            <label>End Date</label>\r\n            <div class=\"input-group\">\r\n                <input type=\"text\"\r\n                       class=\"criteria-drop-date-pick\"\r\n                       show-button-bar=\"false\"\r\n                       data-uib-datepicker-popup=\"shortDate\"\r\n                       data-ng-model=\"rule.endDate\"\r\n                       data-is-open=\"popup2.opened\"\r\n                       data-datepicker-options=\"endDateOptions\"\r\n                       data-ng-required=\"true\"\r\n                       data-close-text=\"Close\"\r\n                       required />\r\n                <span class=\"input-group-btn\">\r\n                    <button type=\"button\" class=\"btn btn-default criteria-attached-button\" ng-click=\"open2()\">\r\n                        <i class=\"fa fa-calendar\"></i>\r\n                    </button>\r\n                </span>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"inline-block\" data-ng-if=\"datesNeeded()\">\r\n        <div class=\"form-group\">\r\n            <label>End Time</label>\r\n            <span uib-timepicker\r\n                  data-ng-model=\"rule.endTime\"\r\n                  class=\"criteria-time\"\r\n                  hour-step=\"1\"\r\n                  minute-step=\"1\"\r\n                  show-spinners=\"false\"\r\n                  required />\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <div class=\"inline-block\" data-ng-if=\"inputNeeded()\">\r\n        <div class=\"form-group\">\r\n            <label>#</label>\r\n            <input type=\"number\" class=\"criteria-number\" data-ng-model=\"rule.value\" min=0>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"inline-block\" data-ng-if=\"periodNeeded() || pluralPeriodNeeded()\">\r\n        <div class=\"form-group\">\r\n            <label>Period</label>\r\n            <select data-ng-model=\"rule.periodType\" class=\"criteria-drop\" data-ng-if=\"periodNeeded()\">\r\n                <option value=\"Day\">Day</option>\r\n                <option value=\"Week\">Week</option>\r\n                <option value=\"Month\">Month</option>\r\n                <option value=\"Quarter\">Quarter</option>\r\n                <option value=\"Year\">Year</option>\r\n            </select>\r\n            <select data-ng-model=\"rule.periodType\" class=\"criteria-drop\" data-ng-if=\"pluralPeriodNeeded()\">\r\n                <option value=\"Day\">Day(s)</option>\r\n                <option value=\"Week\">Week(s)</option>\r\n                <option value=\"Month\">Month(s)</option>\r\n                <option value=\"Year\">Year(s)</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("angular-elastic-builder/types/Multi.html","<div class=\"multi-rule inline-block\">\r\n    <div class=\"inline-block\">\r\n        <div class=\"form-group\">\r\n            <label>Operator</label>\r\n            <select data-ng-model=\"rule.subType\" class=\"criteria-drop\" ng-change=\"clearValues()\">\r\n                <!-- String Options -->\r\n                <option value=\"Contains\">Contains</option>\r\n                <option value=\"DoesNotContain\">Does not contain</option>\r\n                <option value=\"Equals\">Equal to</option>\r\n                <option value=\"NotEquals\">Not equal to</option>\r\n                <option value=\"StartsWith\">Starts with</option>\r\n                <option value=\"EndsWith\">Ends with</option>\r\n                <option value=\"IsEmpty\">Is empty</option>\r\n                <option value=\"IsNotEmpty\">Is not empty</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n    <div class=\"inline-block\" data-ng-if=\"multiNeeded()\">\r\n        <div class=\"form-group\">\r\n            <label>Value(s)</label>\r\n\r\n            <div class=\"criteria-container\">\r\n                <oi-select oi-options=\"choice.Name for choice in guide.choices | orderBy:\'Name\' track by choice.Name\"\r\n                           ng-init=\"getChoices(guide)\"\r\n                           ng-model=\"rule.values\"\r\n                           multiple\r\n                           required\r\n                           oi-select-options=\"{closeList: false}\"\r\n                           placeholder=\"-- Select an Item --\">\r\n                </oi-select>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"inline-block\" data-ng-if=\"inputNeeded() && !multiNeeded()\">\r\n        <div class=\"form-group\">\r\n            <label>Value</label>\r\n            <input class=\"criteria-text\"\r\n                   data-ng-model=\"rule.value\"\r\n                   type=\"text\">\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("angular-elastic-builder/types/Number.html","<div class=\"number-rule inline-block\">\r\n    <div class=\"inline-block\">\r\n        <div class=\"form-group\">\r\n            <label>Operator</label>\r\n            <select data-ng-model=\"rule.subType\" class=\"criteria-drop\">\r\n                <option value=\"Equals\">Equal to</option>\r\n                <option value=\"NotEquals\">Not equal to</option>\r\n                <option value=\"GreaterThanOrEqual\">Greater than or equal to</option>\r\n                <option value=\"GreaterThan\">Greater than</option>\r\n                <option value=\"LessThanOrEqual\">Less than or equal to</option>\r\n                <option value=\"LessThan\">Less than</option>\r\n                <option data-ng-if=\"rule.field.isNullable\" value=\"IsEmpty\">Is empty</option>\r\n                <option data-ng-if=\"rule.field.isNullable\" value=\"IsNotEmpty\">Is not empty</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n    <div class=\"inline-block\" data-ng-if=\"inputNeeded()\">\r\n        <div class=\"form-group\">\r\n            <label>Value</label>\r\n            <!-- Range Fields -->\r\n            <input class=\"criteria-number\"\r\n                   data-ng-model=\"rule.value\"\r\n                   type=\"number\"\r\n                   min=\"{{ guide.minimum }}\"\r\n                   max=\"{{ guide.maximum }}\">\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("angular-elastic-builder/types/String.html","<div class=\"elastic-string inline-block\">\r\n    <div class=\"inline-block\">\r\n        <div class=\"form-group\">\r\n            <label>Operator</label>\r\n            <select data-ng-model=\"rule.subType\" class=\"criteria-drop\">\r\n                <!-- String Options -->\r\n                <option value=\"Contains\">Contains</option>\r\n                <option value=\"DoesNotContain\">Does not contain</option>\r\n                <option value=\"Equals\">Equal to</option>\r\n                <option value=\"NotEquals\">Not equal to</option>\r\n                <option value=\"StartsWith\">Starts with</option>\r\n                <option value=\"EndsWith\">Ends with</option>\r\n                <option value=\"IsEmpty\">Is empty</option>\r\n                <option value=\"IsNotEmpty\">Is not empty</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n    <div class=\"inline-block\" data-ng-if=\"inputNeeded()\">\r\n        <div class=\"form-group\">\r\n            <label>Value</label>\r\n            <input class=\"criteria-text\"\r\n                   data-ng-model=\"rule.value\"\r\n                   type=\"text\">\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("angular-elastic-builder/types/Time.html","<div class=\"time-rule inline-block\">\r\n    <div class=\"inline-block\">\r\n        <div class=\"form-group\">\r\n            <label>Operator</label>\r\n            <select data-ng-model=\"rule.subType\" class=\"criteria-drop\">\r\n                <option value=\"Equals\">Equals</option>\r\n                <option value=\"LessThan\">Before</option>\r\n                <option value=\"GreaterThan\">After</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"inline-block\" data-ng-if=\"timeNeeded()\">\r\n        <div class=\"form-group\">\r\n            <label>Time</label>\r\n            <span uib-timepicker\r\n                  data-ng-model=\"rule.time\"\r\n                  class=\"criteria-time\"\r\n                  hour-step=\"1\"\r\n                  minute-step=\"1\"\r\n                  show-spinners=\"false\"\r\n                  required />\r\n        </div>\r\n    </div>\r\n</div>\r\n");}]);})(window.angular);